const validFonts = ["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "h50", "b500", "b400", "b300", "b200", "b100"];
export const validateFontInputs = (font: string) => {
    return validFonts.includes(font);
};
